import ErrorCodes from "./ErrorCodes";
import 'ReactApp/Services/Prototype/Common';

/**
 * Copy of the app/frontend/assets/js/services/validator/Validator.js
 * that is used in ReactApp and in feature MUST BE replace to special components
 */

const errorTemplates = {
    [ErrorCodes.REQUIRED]: 'Значение должно быть заполнено',
    [ErrorCodes.WRONG_EMAIL]: 'Значение не является валидным email-адресом',
    [ErrorCodes.NO_RUSSIAN_MOBILE_PHONE]: 'Значение должно быть в формате +7 (9XX) XXX-XX-XX',
    [ErrorCodes.REQUIRED_AS_MESSAGE]: '{message}',
};

const Validator: any = {};

Validator.generateError = function(code, mapReplace = {}) {
    return (errorTemplates[code] ?? '').mapReplace(mapReplace);
};

export default Validator;